import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private url = environment.apiUrl;
  private logoutUrl = environment.pdfHost;

  constructor(private httpClient: HttpClient, private router: Router) {}

  login(username: string | null | undefined, password: string | null | undefined) {
    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Access-Control-Allow-Origin', '*');
    // console.log(`${username} - ${password}`);
    return this.httpClient.post(
      `${this.url}/login`,
      {
        username,
        password,
      },
      { headers: headers }
    );
  }

  isLoggedIn() {
    return localStorage.getItem('token') != null;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  decodeToken() {
    const token = this.getToken();
    if (token) {
      return jwtDecode(token) as any;
    }
  }

  removeToken() {
    localStorage.removeItem('token');
  }

  logout() {
    this.removeToken();
    // if (environment.name === 'local') {
    //   this.router.navigate(['/login']);
    // } else {
      window.location.href = this.logoutUrl + '/bye';
    //}
  }
}
